<template>
  <router-link
    :class="className"
    :to="{
      name: 'product',
      params: { product: name }
    }"
  >
    <img class="product-card-img" :src="img" />
    <div class="product-card-name">
      <h4>{{ name }}</h4>
    </div>
    <div class="product-card-content">
      <p v-if="category">{{ category }}</p>
      <div class="product-card-desc">
        <span v-if="description">{{ description }}</span>
      </div>
      <div style="display: flex;justify-content: flex-end;">
        <button class="btn-darkblue">รายละเอียดสินค้า</button>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    name: {
      type: String,
      required: true
    },
    image: {
      type: String
    },
    category: {
      type: String,
      default: " "
    },
    description: {
      type: String,
      default: "รายละเอียด"
    },
    className: {
      type: String,
      default: "product-card-wrapper"
    }
  },
  computed: {
    img() {
      return this.image ? `/img/${this.image}` : '/img/no_image.png'
    }
  }
};
</script>
<style lang="scss" scoped>
.product-card-img {
  height: 200px;
}
.product-card-wrapper {
  display: block;
  background: #fff;
  box-shadow: 1px 8px 11px #88888830;
  max-width: 19rem;
  /* width: 90%; */
  margin-bottom: 30px;
  animation: size 0.5s;
  transform: scale(1);
  transition: all 0.2s ease-in-out;
  text-decoration: none;
}
.product-card-wrapper:hover {
  transform: scale(1.03);
}
img {
  width: 100%;
}
.product-card-name {
  position: absolute;
  margin-top: -30px;
  background: #fff;
  padding: 10px 20px 0px;
  width: 227px;
  color: #000;
  font-weight: 600;
  h4 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.product-card-content {
  padding: 20px;
  color: #000;
  font-weight: 500;
}
.product-card-desc {
  min-height: 55px;
  margin-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.btn-darkblue {
  border-radius: 10px;
}


@media (max-width: 750px) {
  .product-card-wrapper {
    max-width: 90%;
    width: 100%;
  }
  .product-card-img {
    height: 250px;
  }
}
</style>
